import { useEffect, useState, useCallback } from "react";
import { lubeMatchAPI } from "../../../api/api";
import { Panel } from "primereact/panel";
import { ProgressSpinner } from "primereact/progressspinner";
import { LubematchRecommendation } from "../LubematchRecommendation/LubematchRecommendation";
import styles from './Lubematchhistory.module.css';

export const LubematchHistory = ({ isActive = false }) => {
    const [historyList, setHistoryList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [detailsMap, setDetailsMap] = useState({}); 
    const [openIds, setOpenIds] = useState([]); 

    useEffect(() => {
        if (isActive) {
            setIsLoading(true);
            fetchPageData();
        }
    }, [isActive]);

    const fetchPageData = async () => {
        try {
            const resultJson = await lubeMatchAPI.getQueryHistoryList();
            const result = JSON.parse(resultJson.data);
            const queryList = result || [];
            setHistoryList(queryList);
            setDetailsMap({});
        } finally {
            setIsLoading(false);
        }
    };

    const formatDateTime = (dateString) => {
        try {
            const d = new Date(dateString);
            if (isNaN(d)) return dateString || '';
            return d.toLocaleString('uk-UA', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            });
        } catch {
            return dateString || '';
        }
    };

    const loadDetails = useCallback(async (id) => {
        setDetailsMap((prev) => ({
            ...prev,
            [id]: { ...(prev[id] || {}), loading: true },
        }));
        try {
            const resJson = await lubeMatchAPI.GetRecommendationByHistoryId(id);
            const parsed = JSON.parse(resJson.data);
            setDetailsMap((prev) => ({
                ...prev,
                [id]: { loading: false, loaded: true, data: Array.isArray(parsed) ? parsed : [] },
            }));
        } catch (e) {
            setDetailsMap((prev) => ({
                ...prev,
                [id]: { loading: false, loaded: true, data: [] },
            }));
        }
    }, []);

    const onExpand = (item) => {
        if (!detailsMap[item.Id]?.loaded) {
            loadDetails(item.Id);
        }
    };

    if (!historyList.length && !isLoading) {
        return <h5 style={{display:"flex", justifyContent:'center'}} >Ви ще не зробили жодного запиту</h5>;
    }

    return (
        <div className={styles.historyWrapper}>
            {isLoading && (
                <div className={styles.center}>
                    <ProgressSpinner strokeWidth="4" />
                </div>
            )}
            {!isLoading && (
                <div className={styles.list}>
                    {historyList.map((historyItem, idx) => {
                        const header = (
                            <div className={styles.itemHeader}>
                                <div className={styles.date}>{formatDateTime(historyItem.CreatedAt)}</div>
                                <div className={styles.title}>{historyItem.AutoName}</div>
                                <div className={styles.subtitle}>{historyItem.AutoVinNumber}</div>
                            </div>
                        );
                        const state = detailsMap[historyItem.Id] || {};
                        const isOpen = openIds.includes(historyItem.Id);
                        const collapsed = !isOpen;
                        return (
                            <div className={styles.item} key={historyItem.Id || idx}>
                                <Panel
                                    header={header}
                                    toggleable
                                    collapsed={collapsed}
                                    onToggle={(e) => {
                                        const willCollapse = e.value; // true => collapsed, false => expanded
                                        setOpenIds((prev) => {
                                            const id = historyItem.Id;
                                            if (!willCollapse) {
                                                // expand -> add id if not present
                                                if (!prev.includes(id)) {
                                                    onExpand(historyItem);
                                                    return [...prev, id];
                                                }
                                                onExpand(historyItem);
                                                return prev;
                                            } else {
                                                // collapse -> remove id
                                                return prev.filter((x) => x !== id);
                                            }
                                        });
                                    }}
                                >
                                    <div className={styles.itemContent}>
                                        {state.loading && (
                                            <div className={styles.center}>
                                                <ProgressSpinner strokeWidth="4" />
                                            </div>
                                        )}
                                        {!state.loading && state.loaded && (
                                            <LubematchRecommendation recommendationList={state.data || []} hasSearched={true} />
                                        )}
                                        {!state.loading && !state.loaded && (
                                            <div className={styles.placeholder}>Розгорніть, щоб завантажити деталі</div>
                                        )}
                                    </div>
                                </Panel>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};
